import { Segment } from '../../../services/analytics-services/segment';
import { useIsCardComplete } from './use-is-card-complete';
import { useCallback } from 'react';

const HOME_PAGE_FEED_CARD_INTERACTION = 'HOME_PAGE_FEED_CARD_INTERACTION';

export const useTrackHomePageFeedCards = (cardId) => {
  const isCardComplete = useIsCardComplete(cardId);
  return useCallback(
    (buttonType) => {
      Segment.trackEvent(HOME_PAGE_FEED_CARD_INTERACTION, {
        cardId,
        buttonType,
        isCardComplete,
      });
    },
    [cardId, isCardComplete],
  );
};
